var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { buildURL as buildCloudinaryURL } from "../../../../marketplace-next/src/utils/image/cloudinary";
import { IMAGE_MODS } from "./constants";
export var buildURL = function (_a, commonMods) {
    var url = _a.url, width = _a.width, height = _a.height;
    if (commonMods === void 0) { commonMods = IMAGE_MODS; }
    return buildCloudinaryURL(url, __spreadArray(__spreadArray([], commonMods), ["w_" + width, "h_" + height]));
};
//# sourceMappingURL=helpers.js.map